import { render, staticRenderFns } from "./SkeletonTables.vue?vue&type=template&id=7b93fd5a"
import script from "./SkeletonTables.vue?vue&type=script&lang=js"
export * from "./SkeletonTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports